var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseDropdownOptionsWrapper',{attrs:{"id":"dropdown-button","options":_vm.options,"is-horizontal":""},on:{"select":_vm.handleSelectOption,"open":function($event){return _vm.$emit('open')},"close":function($event){return _vm.$emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }